/**
 * stop-algorithm-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client sends a {@link StopAlgorithmRequest} in order to discontinue
 * execution of a running algorithm. If the server satisfied the request, then
 * it sends a {@link StopAlgorithmResponse}; otherwise it sends a negative
 * {@link AcknowledgmentResponse}.
 */
export class StopAlgorithmRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_STOP_ALGORITHM;
	public static tag : MessageTag = MessageTag.REQ_STOP_ALGORITHM;

  /**
   * Construct a new {@link StopAlgorithmResponse}.
   */
  constructor ()
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_STOP_ALGORITHM);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/stop-algorithm-request.ts